import { useCallback, useMemo } from "react";
import { useApi } from "./useApi";
import { useAuth, levelOf } from "../context/AuthContext";
import { toList } from "../lib/api";

/** keep(playerId) -> true when the player belongs to the Varsity/JV level picked in the sidebar. */
export function useLevelFilter(tid) {
  const { level } = useAuth();
  const { data } = useApi(tid && level !== "all" && `/teams/${tid}/players`);
  const levels = useMemo(() => Object.fromEntries(toList(data, ["players"]).map((p) => [p.id, levelOf(p)])), [data]);
  const keep = useCallback((id) => level === "all" || !data || (levels[id] ?? "varsity") === level, [level, data, levels]);
  return { level, keep };
}
